import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Button } from 'telia-front-react';
import config from '../../Config';
import LanguageStore from '../../stores/LanguageStore';

import { TranslationsContext } from '@teliaee/telia-translate';
import { Branch } from '../common/ReservationInterfaces';

interface BranchReservationButtonProps {
  branch: Branch;
  languageStore?: LanguageStore;
}

@observer
class BranchReservationButton extends React.Component<BranchReservationButtonProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  public render() {
    const translate = this.context.translate;
    const {
      branch,
      languageStore: { currentLanguage },
    } = this.props;

    if (!branch.reservationsEnabled) {
      return null;
    }

    return (
      <div>
        <AnalyticsTrigger
          trigger={{
            id: `Link - Broneerin - ${branch.name}`,
            callback: 'onClick',
          }}
        >
          <Button
            text={translate('availableReservation.seeAllAvailableReservations')}
            url={`${config.teliaWebUrl}/${currentLanguage}/kliendisuhtlused/broneerimine?branchId=${branch.branchId}`}
            iconRight="#arrow-right"
            block={true}
          />
        </AnalyticsTrigger>
      </div>
    );
  }
}

export default inject('languageStore')(BranchReservationButton);
